import { useState } from 'react';
import { AllCompetitorsView, GrowthDashboardTopBarActions } from '@elva/ui';
import { useNavigate } from 'react-router-dom';
import { AsyncBoundary } from '@/components/feedback';
import { usePageTopBar } from '@/app/layouts/pageTopBar';
import { viewProps } from '@/data/viewProps';
import { useCompetitors } from '../hooks/useCompetitors';

export function AllCompetitorsPage() {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);

  usePageTopBar({
    actions: <GrowthDashboardTopBarActions />,
  });

  const { data, isPending, isError, error, refetch, isRefetching, isFetching } = useCompetitors(page);

  return (
    <AsyncBoundary
      loading={isPending}
      error={data === undefined && isError ? error : undefined}
      onRetry={refetch}
      retrying={isRefetching}
      isEmpty={data !== undefined && data.items.length === 0 && page === 1}
    >
      <AllCompetitorsView
        {...viewProps({
          items: data?.items,
          stats: data?.stats,
          pagination: data?.pagination,
          loading: isFetching,
          onPageChange: setPage,
          onViewDetails: (id: string) => navigate(`/competitors/${id}`),
        })}
      />
    </AsyncBoundary>
  );
}
